import React from 'react';
import { dateFormatConfig, defaultDateFormat } from '../libs/dateFormatting';
import { timeFormatConfig, defaultTimeFormat } from '../libs/timeFormatting';

export type DateFormatSetting = keyof typeof dateFormatConfig;
export type TimeFormatSetting = keyof typeof timeFormatConfig;

export interface FormatSettings {
  dateFormatSetting: DateFormatSetting;
  timeFormatSetting: TimeFormatSetting;
}

const FormatSettingsContext = React.createContext<FormatSettings>({
  dateFormatSetting: defaultDateFormat as DateFormatSetting,
  timeFormatSetting: defaultTimeFormat as TimeFormatSetting
});

export default FormatSettingsContext;